module.exports = __webpack_public_path__ + "assets/images/spritesheet-2x.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/spritesheet-2x.png
// module id = 257
// module chunks = 1